export default {"src":"/_next/static/media/qr.e8dcbcc7.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};